import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter } from 'rxjs/operators';
import { HaulersService, IHaulersRes } from '@cemex-core/cmx-api';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import {
  OneClickHaulersActionTypes,
  OneClickLoadHaulersAction,
  OneClickLoadHaulersCompleteAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-hauler.actions';

@Injectable()
export class OneClickHaulersEffects {
  loadHaulersCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadHaulersAction(action.payload);
      }),
    ),
  );

  getHaulers = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickHaulersActionTypes.LOAD_HAULERS),
      map((action: OneClickLoadHaulersAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.haulersService
          .getHaulers({
            customerId: order.customer.customerId,
          })
          .pipe(
            map((response: IHaulersRes) => {
              return new OneClickLoadHaulersCompleteAction(response.haulers);
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private haulersService: HaulersService,
  ) {}
}
